import { cn } from '@/utils/cn';

interface CardProps {
  children: React.ReactNode;
  className?: string;
  interactive?: boolean;
  onClick?: () => void;
}

export function Card({
  children,
  className,
  interactive = false,
  onClick,
}: CardProps) {
  return (
    <div
      className={cn(
        'md-card',
        interactive && 'md-card-interactive',
        className
      )}
      onClick={onClick}
    >
      {children}
    </div>
  );
}
